const components = {
  RouterRedirectOrganizationIdDataplantId: () => import('@/shared/RouterRedirectOrganizationIdDataplantId'),
  Overview: () => import('@/cc/components/Overview'),
  Monitoring: () => import('@/cc/components/Monitoring/Monitoring'),
  MonitoringPanelEditor: () => import('@/cc/components/Monitoring/MonitoringPanelEditor'),
  Alerts: () => import('@/cc/components/Alerts/Alerts'),
  AlertEditor: () => import('@/cc/components/Alerts/AlertEditor/AlertEditor'),
  Auditing: () => import('@/cc/components/Auditing/AuditingWrapper'),
  Jobs: () => import('@/cc/components/Jobs/Jobs'),
  LogsExplorer: () => import('@/cc/components/LogsExplorer/LogsExplorer'),
  Settings: () => import('@/cc/components/Settings/Settings')
}

const routes = [
  {
    path: '/',
    name: 'CC',
    component: components.RouterRedirectOrganizationIdDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:organizationId/',
    name: 'CC - Overview (Organization)',
    component: components.Overview,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:organizationId/monitoring_panels',
    name: 'CC - Monitoring (Organization)',
    component: components.Monitoring,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/monitoring_panel',
    name: 'CC - New Monitoring (Organization)',
    component: components.MonitoringPanelEditor,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/monitoring_panel/:id',
    name: 'CC - Edit Monitoring (Organization)',
    component: components.MonitoringPanelEditor,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/alerts',
    name: 'CC - Alerting (Organization)',
    component: components.Alerts,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/alert',
    name: 'CC - New Alert (Organization)',
    component: components.AlertEditor,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/alert/:id',
    name: 'CC - Edit Alert (Organization)',
    component: components.AlertEditor,
    props: route => ({ organizationId: route.params.organizationId, id: route.params.id }),
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/jobs',
    name: 'CC - Jobs Central (Organization)',
    component: components.Jobs,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Jobs Central - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/logs',
    name: 'CC - Logs Explorer (Organization)',
    component: components.LogsExplorer,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'console' },
      title: (route, parent) => `Logs Explorer - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/settings',
    name: 'CC - Settings (Organization)',
    component: components.Settings,
    props: route => ({ organizationId: route.params.organizationId }),
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Settings - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/:projectId/',
    name: 'CC - Overview',
    display_name: 'searchbar.items.cc.overview.display_name',
    description: 'searchbar.items.cc.overview.description',
    searchable: true,
    component: components.Overview,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:organizationId/:projectId/monitoring_panels',
    name: 'CC - Monitoring',
    display_name: 'searchbar.items.cc.monitoring.display_name',
    description: 'searchbar.items.cc.monitoring.description',
    searchable: true,
    component: components.Monitoring,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/:projectId/monitoring_panel',
    name: 'CC - New Monitoring',
    component: components.MonitoringPanelEditor,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/:projectId/monitoring_panel/:id',
    name: 'CC - Edit Monitoring',
    component: components.MonitoringPanelEditor,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Monitoring - ${parent(route, false)}`,
      ready: ['cc_monitoring']
    }
  },
  {
    path: '/:organizationId/:projectId/alerts',
    name: 'CC - Alerting',
    component: components.Alerts,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/:projectId/alert',
    name: 'CC - New Alert',
    component: components.AlertEditor,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/:projectId/alert/:id',
    name: 'CC - Edit Alert',
    component: components.AlertEditor,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId, id: route.params.id }),
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Alerting - ${parent(route, false)}`,
      ready: ['cc_alerts']
    }
  },
  {
    path: '/:organizationId/:projectId/auditing',
    name: 'CC - Auditing',
    component: components.Auditing,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Auditing - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/:projectId/jobs',
    name: 'CC - Jobs Central',
    display_name: 'searchbar.items.cc.jobs_central.display_name',
    description: 'searchbar.items.cc.jobs_central.description',
    searchable: true,
    component: components.Jobs,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Jobs Central - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/:projectId/logs',
    name: 'CC - Logs Explorer',
    display_name: 'searchbar.items.cc.logs_explorer.display_name',
    description: 'searchbar.items.cc.logs_explorer.description',
    searchable: true,
    component: components.LogsExplorer,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'console' },
      title: (route, parent) => `Logs Explorer - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:organizationId/:projectId/settings',
    name: 'CC - Settings',
    display_name: 'searchbar.items.cc.settings.display_name',
    description: 'searchbar.items.cc.settings.description',
    searchable: true,
    component: components.Settings,
    props: route => ({ organizationId: route.params.organizationId, projectId: route.params.projectId }),
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Settings - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'CC' }
  }
]

export const basePath = 'cc/'
export default routes
